import { render, staticRenderFns } from "./create-order.vue?vue&type=template&id=f5450bc0&"
import script from "./create-order.vue?vue&type=script&lang=js&"
export * from "./create-order.vue?vue&type=script&lang=js&"
import style0 from "./create-order.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports